import SearchLayout from '@/pages/search/components/SearchLayout';
import MobileSearchLayout from '@/pages/search/mobile/MobileSearchLayout';
import { isMobileAtom, useRecoil } from '@orcar/common-d2c';

const SearchPage = () => {
  const { recoilValue: isMobile } = useRecoil(isMobileAtom);
  return isMobile ? <MobileSearchLayout /> : <SearchLayout />;
};

export default SearchPage;
